import React, { useState, useEffect } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/global/layout";
import { Tooltip } from "antd";
import FormControl from "../../components/common/FormControl";
import shared from "./shared";
import environment from "../../environment";
import { useSelector } from "react-redux";
import { FiPlus, FiTrash } from "react-icons/fi";
import { toast } from "react-toastify";

const AddEdit = () => {
    const { id } = useParams()
    const history = useNavigate()
    const user = useSelector((state) => state.user);
    const [submitted, setSubmitted] = useState(false)
    const [users, setUsers] = useState([])
    const [members, setMember] = useState([{ firstName: '', lastName: "", email: '', fullName: "" }])

    const handleSubmit = (e) => {
        e.preventDefault()
        setSubmitted(true)
        let method = 'post'
        let url = shared.addApi
        let value = {
            data: members.map(itm => {
                return {
                    ...itm,
                    role: 'member',
                    addedBy: user._id,
                    groupId: user.groupId._id,
                    fullName: (itm?.firstName ?? '') + ' ' + (itm?.lastName ?? '')

                }
            })
        }
        if (value.id) {
            method = 'put'
            url = 'api/attendees/update'
        } else {
            delete value.id
        }

        loader(true)
        ApiClient.allApi(url, value, method).then(res => {
            if (res.success) {
                // ToastsStore.success(res.message)
                toast(res?.message)
                history(`/${shared.url}`)
            }
            loader(false)
        })
    }

    const getUsers = (p = {}) => {
        let f = {
            ...p,
            role: environment.userRoleId,
            groupId: user?.groupId?._id || '',
            isDeleted: false
        }
        ApiClient.get('api/user/members', f).then(res => {
            if (res.success) {
                let data = res.data.map(itm => {
                    return { ...itm, id: itm._id }
                })
                data = data.filter(itm => itm.email != user.email)
                setUsers(data)
            }
        })
    }

    useEffect(() => {
        if (id) {
            loader(true)
            ApiClient.get('api/attendees/detail', { id }).then(res => {
                if (res.success) {
                    let value = res.data
                    // let payload = form

                    // Object.keys(payload).map(itm => {
                    // payload[itm] = value[itm]
                    // })

                    // payload.id = id
                    // setform({
                    // ...payload
                    // })

                }
                loader(false)
            })
        }
        getUsers()
    }, [id])

    // cw: add new entry at top, existing entries move down (like Invite Members/Guests)
    const addMore = () => {
        let arr = [...members];
        let payload = { fullName: '', email: '', lastName: "", firstName: "" };
        arr.unshift(payload);
        setMember(arr);
    }

    // const updateMember = (i,key='',value='') => {
    // let arr = members
    // arr[i][key]=value
    // setMember([...arr])
    // }
    const updateMember = (index, field, event) => {
        const value = event.target.value.replace(/\s/g, ''); // Remove spaces from the input value
        const updatedMembers = [...members];
        updatedMembers[index][field] = value;
        setMember(updatedMembers);
    };

    const updateMemberAll = (i, values) => {
        let arr = members
        arr[i] = values
        setMember([...arr])
    }

    const removeMember = (i) => {
        let arr = members
        arr = arr.filter((itm, ind) => ind != i)
        setMember([...arr])
    }

    // cw: CSV bulk import. Robust parse (handles quoted fields with embedded commas/newlines/""),
    // maps known headers (works with our template AND a Circle.so export), and loads rows into the
    // member list with profile prefill. Rows are reviewed, then Saved through the normal invite flow.
    const HEADER_MAP = {
        'first name': 'firstName', 'firstname': 'firstName',
        'last name': 'lastName', 'lastname': 'lastName',
        'email': 'email',
        'headline': 'headline',
        'bio': 'bio',
        'location': 'location',
        'website': 'website',
        'profile url': 'profileUrl', 'profileurl': 'profileUrl',
        'linkedin url': 'linkedInUrl', 'linkedin': 'linkedInUrl',
        'company': 'company',
    };

    const parseCSV = (text) => {
        const rows = [];
        let row = [], field = '', inQuotes = false;
        for (let i = 0; i < text.length; i++) {
            const c = text[i];
            if (inQuotes) {
                if (c === '"') {
                    if (text[i + 1] === '"') { field += '"'; i++; }
                    else inQuotes = false;
                } else field += c;
            } else {
                if (c === '"') inQuotes = true;
                else if (c === ',') { row.push(field); field = ''; }
                else if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; }
                else if (c === '\r') { /* skip CR */ }
                else field += c;
            }
        }
        if (field.length || row.length) { row.push(field); rows.push(row); }
        return rows;
    };

    const handleCsvUpload = (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (ev) => {
            try {
                const rows = parseCSV(String((ev.target && ev.target.result) || ''));
                if (!rows.length) { toast.error('CSV appears to be empty'); return; }
                const headers = rows[0].map(h => (h || '').trim().toLowerCase());
                const idx = {};
                headers.forEach((h, i) => { if (HEADER_MAP[h] !== undefined) idx[HEADER_MAP[h]] = i; });
                if (idx.email === undefined) { toast.error('CSV must include an "Email" column'); return; }
                const get = (cols, k) => (idx[k] !== undefined ? (cols[idx[k]] || '').trim() : '');
                const parsed = [];
                for (let r = 1; r < rows.length; r++) {
                    const cols = rows[r];
                    const email = get(cols, 'email');
                    if (!email) continue;
                    const firstName = get(cols, 'firstName');
                    const lastName = get(cols, 'lastName');
                    parsed.push({
                        firstName, lastName, email,
                        fullName: `${firstName} ${lastName}`.trim(),
                        profile: {
                            headline: get(cols, 'headline'),
                            bio: get(cols, 'bio'),
                            location: get(cols, 'location'),
                            // cw: CSV "Website" fills the Company URL field; CSV "Profile URL" fills
                            // the Website URL field (applied in acceptInvitation).
                            website: get(cols, 'website'),
                            profileUrl: get(cols, 'profileUrl'),
                            linkedInUrl: get(cols, 'linkedInUrl'),
                            company: get(cols, 'company'),
                        },
                    });
                }
                if (!parsed.length) { toast.error('No rows with an email were found'); return; }
                setMember(parsed);
                toast.success(`Loaded ${parsed.length} member(s) from the file. Review below, then click Send Invite`);
            } catch (err) {
                toast.error('Could not read that CSV file');
            }
            e.target.value = '';
        };
        reader.readAsText(file);
    };

    const downloadTemplate = () => {
        const csv = 'First Name,Last Name,Email,Headline,Bio,Location,Website,Profile URL,LinkedIn URL\n'
            + 'Jane,Doe,jane@example.com,SaaS Attorney,"Short bio about Jane",San Jose CA,https://company.com,https://janedoe.com,https://linkedin.com/in/jane\n';
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = 'member_import_template.csv';
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    return <>
        <Layout>
            <form onSubmit={handleSubmit}>
                <div className="pprofile1">

                    <div className="flex justify-between gap-2">
                        <div className='flex items-center mb-8'>
                            <Tooltip placement="top" title="Back">

                                <Link to={`/${shared.url}`} className="!px-4 py-2 flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all gap-1 mr-2"><i className='fa fa-angle-left text-lg'></i></Link>
                            </Tooltip>
                            <div>
                                <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">
                                    {/* {id ? 'Edit' : 'Add'} */}
                                    {shared.title}
                                </h3>
                                {/* <p class="text-sm font-normal text-[#75757A]">Here you can see all about your {shared.title}</p> */}
                            </div>
                        </div>

                     

                        {/* <div className="text-right mt-3">
<button type="button" onClick={addMore} className="text-white bg-orange-400 bg-orange-600 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center gap-2"><FiPlus/> Add More</button> 
</div> */}
                    </div>

                    {/* cw: CSV bulk import — invite many members at once and prefill their profiles. */}
                    <div className="border border-gray-200 rounded-xl p-4 mb-4 bg-gray-50">
                        <div className="flex flex-wrap items-center justify-between gap-2">
                            <div>
                                <h4 className="text-base font-semibold text-[#111827]">Bulk import from CSV</h4>
                                <p className="text-sm text-[#75757A]">Upload a CSV to invite multiple members at once and prefill their profiles.</p>
                            </div>
                            <div className="flex items-center gap-2">
                                <button type="button" onClick={downloadTemplate} className="text-orange-600 hover:underline text-sm font-medium">Download template</button>
                                <label className="text-white bg-orange-600 hover:bg-orange-700 font-medium rounded-lg text-sm px-4 py-2.5 cursor-pointer">
                                    Upload CSV
                                    <input type="file" accept=".csv,text/csv" onChange={handleCsvUpload} className="hidden" />
                                </label>
                            </div>
                        </div>
                        <p className="text-xs text-gray-500 mt-2">
                            Required header: <b>Email</b>. Optional: <b>First Name, Last Name, Headline, Bio, Location, Website, LinkedIn URL</b>.
                            A Circle.so member export works too.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 gap-4">

                        {members.map((itm, i) => {
                            return <>
                                <div key={i} className="border border-gray-200 rounded-xl p-4 flex flex-col gap-4">

                                    <div className="flex gap-4 items-center w-full">

                                    <div className="w-full" >
                                            <label>Email</label>
                                            <input
                                                type="email"
                                                name="Email"
                                                placeholder="Email"
                                                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                                                value={itm.email}
                                                onChange={e => updateMember(i, 'email', e)}
                                                required
                                            />
                                        </div>

                                    <div className="capitalize w-full">
                                        <div>
                                            <label>First Name</label>
                                        </div>
                                        <input
                                            type="text"
                                            name="firstName"
                                            placeholder="First Name"
                                            className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                                            value={itm.firstName}
                                            onChange={(e) => updateMember(i, 'firstName', e)}
                                            onKeyPress={(e) => {
                                                if (e.key === ' ') e.preventDefault();
                                            }}
                                            required
                                        />
                                    </div>
                                    <div className="w-full">
                                        <div>
                                            <label>Last Name</label>
                                        </div>
                                        <input
                                            type="text"
                                            name="lastName"
                                            placeholder="Last Name"
                                            className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                                            value={itm.lastName}
                                            onChange={(e) => updateMember(i, 'lastName', e)}
                                            onKeyPress={(e) => {
                                                if (e.key === ' ') e.preventDefault();
                                            }}
                                            required
                                        />
                                    </div>

                                    {members.length > 1 ?
                                        <button type="button" onClick={() => removeMember(i)} className="text-black cursor-pointer flex items-center gap-2 focus:ring-0 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm py-2.5 text-center mt-5">
                                            <span className="material-symbols-outlined">delete</span>
                                        </button>
                                    : ''}

                                    {i === 0 && (
                                        <div className="mt-5">
                                            <button
                                                type="button"
                                                onClick={addMore}
                                                className="text-white bg-orange-600 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                            >
                                                +
                                            </button>
                                        </div>
                                    )}

                                    </div>

                                </div>
                            </>
                        })}

                    </div>
                    <div className="flex items-center justify-end gap-4 mt-6">
                        <button type="submit" className="text-white focus:ring-4 focus:outline-none hover:opacity-80 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Send Invite</button>
                    </div>

                </div>

            </form>
        </Layout>
    </>
}

export default AddEdit
